<template>
  <div id="app" class="palta-desktop">
    <palta-workspace class="main">
      <palta-view scroll="vertical">
        <!-- <app-header-bar slot="header" /> -->
        <router-view />
      </palta-view>
    </palta-workspace>
    <palta-notifications />
  </div>
</template>

<script>
import AppHeaderBar from '@/components/app/app_header_bar.vue';

export default {
  components: {
    AppHeaderBar,
  },
  errorCaptured(/* err, vm, info */) {
    this.$notify({ type: 'error', message: 'Something went wrong!' });
  },
  beforeCreate() {
    const isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
    
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener('change', function (e) {
      console.log(e.matches);
    });

    let userAppearance = this.$cookies.get('eo-appearance') || null;

    let selectedTheme = 'light';

    if (userAppearance === 'dark') selectedTheme = 'dark';
    else if (userAppearance === 'light') selectedTheme = 'light';
    else if (isDarkMode) selectedTheme = 'dark';

    if (selectedTheme === 'dark') document.documentElement.setAttribute('data-theme', 'dark');
  },
  mounted() {
    this.$plausible.trackPageview();
  }
};
</script>

<style lang="stylus">
@import './stylus/main';

body {
  font: -apple-system-body;
  display: flex;
  flex: 1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  #container.loader-spinner {
    background: transparent;
  }
}

.main {
  display: flex;
  flex: 1;
}

#app
  // background: var(--eo-document-sm-background);
  display flex
  flex 1
</style>
